
export const APPLICATION_INITIAL_MODE = 'Default';
